import React from 'react';
// import BillieLogo from '@assets/logos/billie_logo.png';
import MPGLogo from '@assets/logos/mpg_wide.png';
// import MPGLogo from '@assets/logos/mpg.svg';
import { Link } from 'react-router-dom';

interface Props {
  width: number;
  href?: string
}

export const Logo = ({ width, href }: Props) => (
  <Link to={href ?? '/'} style={{ textAlign: 'center' }}>
    <img
      src={MPGLogo}
      alt="MPG"
      style={{ maxWidth: '90%', objectFit: 'contain' }}
      width={(width < 220) ? 220 : width}
    // layout="fill"
    />
  </Link>
);
